import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "percentage",
  standalone: false,
})
export class PercentagePipe implements PipeTransform {
  transform(value: number, digits?: number, showUnits?: boolean): string {
    if (!value && value !== 0) {
      return "Unavailable";
    }

    let result;

    if (digits || digits === 0) {
      result = value.toFixed(digits);
    }

    if (showUnits) {
      result += ` %`;
    }

    return result;
  }
}
